import { useMutation, useQueryClient } from '@tanstack/react-query';

import { actionItemCommentsKey } from '@pages/ActionItem/services/useActionItemCommentsQuery';
import { locationsAssetsKey } from '@pages/Sensors/services/useLocationsAssetsQuery';

import { actionItemKey } from '@services/actionItem/useActionItemQuery';
import { actionItemsGlobalOrIdListKey } from '@services/actionItem/useActionItemsGlobalOrIdListQuery';
import { apiClient } from '@services/apiClient';

const editSnoozeFn = ({
  actionItemId,
  description,
  end_snooze_date,
}: {
  actionItemId: number;
  description: string;
  end_snooze_date: string;
}) =>
  apiClient.put(`${APP_API_URL_V2}fsd/action-item/${actionItemId}/edit-snooze`, {
    description,
    end_snooze_date,
  });

export const useEditSnoozeMutation = (actionItemId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editSnoozeFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
      queryClient.invalidateQueries({ queryKey: [actionItemsGlobalOrIdListKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [locationsAssetsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });

    },
  });
};
